import { createAction, props } from '@ngrx/store';

export const isMobileChanged = createAction('[Device] breakpointChanged', props<{ isMobile: boolean }>());
